module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp3_7005.5da1c2a6.png";